import { IPromoCodeValue } from 'components';
import { EPaymentMethod } from 'types';

export enum EDepositType {
  BONUS = 'BONUS',
  DEPOSIT = 'DEPOSIT',
}

export interface IFormValues {
  type: EDepositType;
  sum: number | '';
  clientUUID: string | null;
  method: Exclude<EPaymentMethod, 'DEPOSIT' | 'BONUS'> | null;
  promoCode: IPromoCodeValue | null;
  card_sum: number | '';
  cash_sum: number | '';
  comment: string;
}

export interface IDepositModalProps {
  className?: string;
  defaultClientUUID?: string | null;
  onClose: CallableFunction;
}
